import React from 'react';

export function SeparatorWithDownArrow () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="365"
      height="32"
      fill="none"
      viewBox="0 0 365 32"
    >
      <rect width="365" height="2" y="15" fill="#4FADA6" rx="1" />
      <circle cx="183" cy="16" r="16" fill="#4FADA6" />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M183 10v12.563m0 0l-6.125-6.125M183 22.563l6.125-6.125"
      />
    </svg>
  );
}
